import type { MailboxInfo } from 'owa-client-types';
import {
    isAccountExplicitLogon,
    isMailboxSharedResourceArchive,
} from 'owa-account-shared-mailbox-utils';

export default function isFindRelatedConversationEnabled(mailboxInfo: MailboxInfo): boolean {
    if (isAccountExplicitLogon(mailboxInfo)) {
        return true;
    } else if (mailboxInfo.type == 'UserMailbox') {
        return true;
    } else if (isMailboxSharedResourceArchive(mailboxInfo)) {
        return false;
    } else if (mailboxInfo.type == 'ArchiveMailbox') {
        return true;
    }
    return false;
}
